(() => {
  const script = document.getElementById('SalesRepPilotBridge');
  if (!script) return;
  const CACHE_KEY = 'salesRepPilotAccountsV1';
  const PENDING_KEY = 'salesRepPilotPendingV1';
  try {
    const pending = JSON.parse(sessionStorage.getItem(PENDING_KEY) || 'null');
    if (!pending) return;
    const cache = JSON.parse(localStorage.getItem(CACHE_KEY) || 'null');
    const now = Date.now();
    if (!cache || !Array.isArray(cache.accounts) || now - cache.savedAt > 2 * 60 * 60 * 1000 || now - pending.savedAt > 5 * 60 * 1000 || !cache.accounts.some((account) => account.id === pending.id && account.email === pending.email)) {
      sessionStorage.removeItem(PENDING_KEY);
      return;
    }
    if (script.dataset.customerId === pending.id) {
      sessionStorage.removeItem(PENDING_KEY);
      return;
    }
    if (!script.dataset.customerId && window.location.pathname !== '/account/login') {
      window.location.replace(script.dataset.loginUrl);
    }
  } catch (_error) {
    sessionStorage.removeItem(PENDING_KEY);
  }
})();
